import React from 'react'

interface FadeInProps {
	children: React.ReactNode
	isVisible: boolean
	delay?: number
	duration?: number
	direction?: 'up' | 'down' | 'left' | 'right' | 'none'
	className?: string
	style?: React.CSSProperties
	as?: keyof JSX.IntrinsicElements
}

export default function FadeIn({
	children,
	isVisible,
	delay = 0,
	duration = 700,
	direction = 'up',
	className = '',
	style = {},
	as: Component = 'div',
}: FadeInProps) {
	const getTransform = () => {
		if (!isVisible) {
			switch (direction) {
				case 'up':
					return 'translate-y-8'
				case 'down':
					return '-translate-y-8'
				case 'left':
					return 'translate-x-8'
				case 'right':
					return '-translate-x-8'
				case 'none':
					return ''
				default:
					return 'translate-y-8'
			}
		}
		return 'translate-y-0 translate-x-0'
	}

	const combinedClassName = `transition-all ease-out ${
		isVisible ? 'opacity-100' : 'opacity-0'
	} ${getTransform()} ${className}`

	const combinedStyle = {
		transitionDuration: `${duration}ms`,
		transitionDelay: isVisible ? `${delay}ms` : '0ms',
		...style,
	}

	return (
		<Component className={combinedClassName} style={combinedStyle}>
			{children}
		</Component>
	)
}

